for (const element of document.querySelectorAll('.form-composite')) {
    const label = element.querySelector(':scope > legend')
    if (label) {
        label.setAttribute('tabindex', '0')
        label.addEventListener('click', (e) => {
            element.classList.toggle('open')
        })
    }
}

document.addEventListener('click', (e) => {
    const emitter = e.target.closest('.form-composite')
    for (const element of document.querySelectorAll('.form-composite.open')) {
        if (emitter !== element) element.classList.remove('open')
    }
})
